import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import ClientSlider from "../Elements/ClientSlider";
import ServiceBox from "../Elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage1 from "../../assets/img/add/1.png";
import AddImage2 from "../../assets/img/add/2.png";
import AddImage3 from "../../assets/img/add/3.png";
import AddImage4 from "../../assets/img/add/4.png";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function Services() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  console.log("Backend URL:", backendUrl);
  const { name } = useParams();
  console.log("Name:", name);

  const [data, setData] = useState();
  useEffect(() => {
    axios
      .get(`${backendUrl}/cms/name/${name}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching school data:", err);
      });
  }, [backendUrl, name]);
  console.log("Data:", data);

  return (
    <Wrapper id="services">
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{data?.section2?.heading || "Our Awesome Courses"}</h1>
            <p className="font13" style={{ maxWidth: "600px" }}>
              {data?.section2?.content ||
                "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt utlabore et dolore magna aliquyam erat, sed diam voluptua."}
              <br />
            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                image={data?.section2?.content1img || ""}
                title={data?.section2?.content1title || "Branding"}
                subtitle={data?.section2?.content1content || "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat."}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                image={data?.section2?.content2img || ""}
                title={data?.section2?.content2title || "Branding"}
                subtitle={data?.section2?.content2content || "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat."}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                image={data?.section2?.content3img || ""}
                title={data?.section2?.content3title || "Branding"}
                subtitle={data?.section2?.content3content || "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat."}
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                image={data?.section2?.content4img || ""}
                title={data?.section2?.content4title || "Branding"}
                subtitle={data?.section2?.content4content || "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat."}
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
       
        {data?.extra1?.isNeeded && (
          <div className="lightBg">
            <div className="container">
              <Advertising className="flex督SpaceCenter">
                <AddLeft>
                  <h4 className="font15 semiBold">{data?.extra1?.companyHeading || "A few words about company"}</h4>
                  <h2 className="font40 extraBold">{data?.extra1?.title || "A Study of Creativity"}</h2>
                  <p className="font12">
                    {data?.extra1?.content ||
                      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."}
                  </p>
                  <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                    <div style={{ width: "190px" }}>
                      <FullButton
                        title={data?.extra1?.buttonLabel1 || "Get Started"}
                        action={() => alert("clicked")}
                      />
                    </div>
                    <div style={{ width: "190px", marginLeft: "15px" }}>
                      <FullButton
                        title={data?.extra1?.buttonLabel2 || "Contact Us"}
                        action={() => alert("clicked")}
                        border
                      />
                    </div>
                  </ButtonsRow>
                </AddLeft>
                <AddRight>
                  <AddRightInner>
                    <div className="flexNullCenter">
                      <AddImgWrapp1 className="flexCenter">
                        <img
                          src={data?.extra1?.img1 ? `${backendUrl}${data?.extra1?.img1}` : AddImage1}
                          alt="office"
                          style={{ width: "285px", height: "406px",  }}
                        />
                      </AddImgWrapp1>
                      <AddImgWrapp2>
                        <img
                          src={data?.extra1?.img2 ? `${backendUrl}${data?.extra1?.img2}` : AddImage2}
                          alt="office"
                          style={{ width: "197px", height: "333px",  }}
                        />
                      </AddImgWrapp2>
                    </div>
                    <div className="flexNullCenter">
                      <AddImgWrapp3>
                        <img
                          src={data?.extra1?.img3 ? `${backendUrl}${data?.extra1?.img3}` : AddImage3}
                          alt="office"
                          style={{ width: "112px", height: "125px",  }}
                        />
                      </AddImgWrapp3>
                      <AddImgWrapp4>
                        <img
                          src={data?.extra1?.img4 ? `${backendUrl}${data?.extra1?.img4}` : AddImage4}
                          alt="office"
                          style={{ width: "197px", height: "224px", }}
                        />
                      </AddImgWrapp4>
                    </div>
                  </AddRightInner>
                </AddRight>
              </Advertising>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
}

// Styled components remain unchanged
const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 20%;
  margin-right: 5%;
  padding: 80px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;